module.exports = __webpack_public_path__ + "e6d691eb2ca01a0d658477a3419f64ec.MP3";